// actions/pubsub/remove.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

export function removeHasErrored(bool) {
  return {
    type: 'REMOVE_HAS_ERRORED',
    hasErrored: bool
  };
}

export function removeIsLoading(bool) {
  return {
    type: 'REMOVE_IS_LOADING',
    isLoading: bool
  };
}

export function removeFetchDataSuccess(response) {
  return {
    type: 'REMOVE_FETCH_DATA_SUCCESS',
    response
  };
}

export function removeFetchData(host, params) {
  return (dispatch) => {
    dispatch(removeIsLoading(true));
    dispatch(removeHasErrored(false));
    fetch(host + 'admin/remove', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(removeFetchDataSuccess(result));
            PubSub.publish('pubsub.list.reload', true);
          })
          .catch(() => dispatch(removeHasErrored(true)));
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(removeHasErrored(true));
      dispatch(removeIsLoading(false));
    });
  };
}